import { IIncome } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	incomeNo: number
	date: number
	categoryId: string
	fields: {
		fieldId: string
		value: any
	}[]
}

export async function incomeAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/income/add/v1"
	const requester = new ApiRequester<RequestDataShape, IIncome>(endpoint)
	return await requester.sendRequest(payload, token)
}
